module.exports = __webpack_public_path__ + "img/ic_check-incircle.0edc6c60.svg";